// extracted by mini-css-extract-plugin
export default {"Wrapper":"TasksView_Wrapper__tWhqb"};